<template>
  <div class="conta">
    <!-- 面包屑 -->
    <div class="haders_o">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/whens' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>每日金价</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="conten_pri">
        <div class="pri">
        <span>数据来源：上海黄金交易所，更新时间：{{ GoldPrice.uptime == undefined ?"数据请求中...": GoldPrice.uptime}},
          实时价格：>>> 黄金9999 = {{ GoldPrice.last_price == undefined ?"数据请求中...":GoldPrice.last_price + "元" }} ; 铂金9995
          = {{ PtNum.last_price == undefined ?"数据请求中...":PtNum.last_price + "元" }} ; 白银T+D =
          {{ Silver.last_price == undefined ?"数据请求中...": Silver.last_price / 1000 + "元" }}
        </span>
      </div>
    </div>
    <!-- 内容栏 -->
    <div class="content">

      <Goldprice @child-goldprice="emitGoldprice"></Goldprice>

     
      
    </div>
  </div>
</template>
<script>
// import dayjs from "dayjs";
import Goldprice from "@/components/realTimesGold/Goldprice";

export default {
  name: "RealTimesGold",

  data() {
    return {
      // todayDate: "",
      GoldPrice: {},
      PtNum: {},
      Silver: {},
    };
  },
  components:{
    Goldprice
  },
  methods: {
  
    //接收子组件传来的数据
    emitGoldprice(GoldPrice,PtNum,Silver){
      this.GoldPrice = GoldPrice,
      this.PtNum = PtNum,
      this.Silver = Silver
    }
  },
  created() {},
  mounted() {
    // this.todayDate = dayjs().format("YYYY-MM-DD");
    
    // this.getGoldprice();
  },
};
</script>
<style scoped>
.haders_o {
  width: 99%;
  height: 100%;
  padding: 10px 10px;
  background-color: #ffffff;
}
.content {
  /* margin: 10px auto; */
  width: 100%;
  height: 80vh;
  background-color: #ffffff;
}
.pri{
    /* margin: 10px auto; */
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    color: blue;
    font-size: 20px;
    /* font-weight: bolder; */
}
.conten_pri{
    margin: 10px auto;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
}
</style>